import React from 'react'
import { Translator } from '@morningtrain/react-translations'
import DepartmentEditForm from 'pages/app/settings/departments/partials/DepartmentEditForm'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'

export default function DepartmentsEdit () {
  return (
    <AdminPageWithSmartview>
      <Translator namespace='settings.departments.edit'>
        <DepartmentEditForm />
      </Translator>
    </AdminPageWithSmartview>
  )
}
